import { render } from "./RDFSearch.vue?vue&type=template&id=1f9cde06&scoped=true"
import script from "./RDFSearch.vue?vue&type=script&lang=js"
export * from "./RDFSearch.vue?vue&type=script&lang=js"

import "./RDFSearch.vue?vue&type=style&index=0&id=1f9cde06&lang=scss"
import "./RDFSearch.vue?vue&type=style&index=1&id=1f9cde06&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f9cde06"]])

export default __exports__